export default "__VITE_ASSET__bWHq5r3I__"